import React, { useState } from "react";
import "../css/home.css";
import {
    Box, Button, Typography, Stack, Accordion,
    AccordionSummary,
    AccordionDetails
} from "@mui/material";

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// Mock data array for the FAQs
const faqData = [
  {
    id: 'panel1',
    question: 'Why is this free than others?',
    answer: 'We Provide a free version of the application for home use, which is best for home use and good for app management to segregate different types of applications. The premium versions are available for those who want to support the project and get additional features.',
  },
  {
    id: 'panel2',
    question: 'Is this Open-Source?',
    answer: 'Yes, our application is open-source and available on GitHub for anyone to view, contribute, and modify. yet the project was under AGPL-3.0 License, which means you can use it for free, but if you want to modify it and distribute it, you must also make your modifications open-source under the same license.',
  },
  {
    id: 'panel3',
    question: 'Is the features of the free version limited?',
    answer: 'We provide some features which makes available for free and paid versions, however the app monitoring and several features will be available in the paid versions, which is best for those who want to support the project and get additional features.',
  }
];

const downloadFiles = [
    {
        id: 1,
        title: "RonCafeSuite-Client",
        downloadLink: "https://github.com/RMPlaysMCYT/RonCafeApp/releases"
    },
    {
        id: 2,
        title: "RonCafeSuite-Admin",
        downloadLink: "https://github.com/RMPlaysMCYT/roncafeapp_manager/releases"
    }
];

const sourceCodeLinks = [
    {
        id: 1,
        title: "RonCafeSuite-Client",
        downloadLink: "https://github.com/RMPlaysMCYT/RonCafeApp"
    },
    {
        id: 2,
        title: "RonCafeSuite-Admin",
        downloadLink: "https://github.com/RMPlaysMCYT/roncafeapp_manager"
    }
];

// Converted to a Functional Component
const Download: React.FC = () => {
    // Hooks now work correctly inside the functional component
    const [expanded, setExpanded] = useState<string | false>(false);

    // Added types for TypeScript compatibility
    const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <div className='DownloadPage'>
            <Box sx={{ py: 4, px: 3, maxWidth: 800, mx: 'auto' }}>
                <Typography variant="h3" component="h1" gutterBottom fontWeight="bold">
                    Download Page
                </Typography>

                <Typography variant="subtitle1" color="text.secondary" gutterBottom>
                    Here you can download the application.
                </Typography>

                <Box sx={{ mt: 4, mb: 4 }}>
                    <Typography variant="body1" paragraph>
                        We provide the full version for free, which is best for home use and good for app management to segregate different types of applications.
                    </Typography>

                    <Typography variant="body1" paragraph>
                        This project was created by one person, which takes time to create and maintain. If you want to support the project, you can purchase the premium versions.
                    </Typography>

                    <Typography variant="h6" sx={{ mt: 4, mb: 2 }}>
                        Download the apps here:
                    </Typography>

                    {/* Using Stack to easily space the buttons side-by-side */}
                    <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
                        {downloadFiles.map((file, index) => (
                            <Button
                                key={file.id}
                                variant="contained"
                                // Assign primary color to the first button, secondary to the rest
                                color={index === 0 ? "primary" : "secondary"}
                                href={file.downloadLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{ textTransform: 'none', px: 3, py: 1 }}
                            >
                                {file.title}
                            </Button>
                        ))}
                    </Stack>

                    <Box sx={{ maxWidth: 700, margin: '0 auto', padding: 3, mt: 4 }}>
                        <Typography variant="h4" component="h2" sx={{ mb: 4, textAlign: 'center', fontWeight: 'bold' }}>
                            Frequently Asked Questions
                        </Typography>

                        {faqData.map((faq) => (
                            <Accordion
                                key={faq.id}
                                expanded={expanded === faq.id}
                                onChange={handleChange(faq.id)}
                                sx={{
                                    mb: 1.5,
                                    boxShadow: 'none',
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    borderRadius: '8px !important', 
                                    '&:before': { display: 'none' },
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon color="primary" />}
                                    aria-controls={`${faq.id}-content`}
                                    id={`${faq.id}-header`}
                                    sx={{
                                        backgroundColor: expanded === faq.id ? 'action.hover' : 'inherit',
                                        fontWeight: 600,
                                    }}
                                >
                                    <Typography sx={{ fontWeight: 600 }}>{faq.question}</Typography>
                                </AccordionSummary>
                                <AccordionDetails sx={{ borderTop: '1px solid', borderColor: 'divider', pt: 2 }}>
                                    <Typography color="text.secondary">
                                        {faq.answer}
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </Box>
                </Box>
            </Box>
        </div>
    );
};

export default Download;